<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  name: 'AppInventory',
  props: {
    value: {
      type: String,
      validator(v) {
        return ['web', 'mobile_web', 'mobile_app'].includes(v)
      },
    },
  },
  computed: {
    text() {
      switch (this.value) {
        case 'web':
          return 'WEBブラウザ'
        case 'mobile_app':
          return 'アプリ'
        default:
          return ''
      }
    },
  },
}
</script>

<style></style>
